import { axios } from "@/utils/request";

const api = {
  searchCouponLog: '/62bbaded64cd7',
}
export default {
  searchCouponLog:(parameter)=>{
    const params = Object.assign(parameter,{
      page:parameter.pageNo||1,
      size:parameter.pageSize||10
    })
    return axios({
      url:api.searchCouponLog,
      method:'get',
      params
    }).then(res=>{
      // console.log(res,'查券记录')
      return {
        data: res.data.list || [],
        pageNo: params.page,
        pageSize: params.size,
        totalCount: res.data.count
      }
    })
  }
}